module.exports = __webpack_public_path__ + "img/1.4fcb03fa.jpg";